import { z } from 'zod';

export const glossaryFormSchema = z.object({
  name: z.string().min(1, 'Name is required').max(256, 'Name must be less than 256 characters'),
  categoryId: z.string().optional().or(z.literal('')),
  aliases: z.array(z.string()).default([]),
  tags: z.array(z.string()).default([]),
  definition: z.string().min(1, 'Definition is required'),
});

export type GlossaryFormData = z.infer<typeof glossaryFormSchema>;
